import { render, staticRenderFns } from "./MembershipBadge.vue?vue&type=template&id=9349bbb2&scoped=true&"
import script from "./MembershipBadge.vue?vue&type=script&lang=js&"
export * from "./MembershipBadge.vue?vue&type=script&lang=js&"
import style0 from "./MembershipBadge.vue?vue&type=style&index=0&id=9349bbb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../registration-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9349bbb2",
  null
  
)

export default component.exports